// src/components/text/text.tsx
import { createElement } from "react";
import { tv } from "tailwind-variants";
var text = tv(
  {
    base: "[&>a]:font-semibold",
    variants: {
      weight: {
        light: "font-light",
        normal: "font-normal",
        medium: "font-medium",
        semibold: "font-semibold",
        bold: "font-bold"
      },
      variant: {
        bodyMD: "text-base leading-6",
        // font size: 16px
        bodySM: "text-sm leading-6",
        // font size: 14px
        labelMD: "text-xs leading-4",
        // font size: 12px
        labelSM: "text-xxs leading-3-5"
        // font size: 10px
      }
    }
  },
  {
    twMergeConfig: {
      classGroups: {
        "font-size": [{ text: ["xxs"] }],
        "line-height": [{ leading: ["3-5"] }]
      }
    }
  }
);
var Text = ({
  weight = "normal",
  as = "p",
  variant = "bodyMD",
  className,
  children,
  ...rest
}) => {
  const style = text({ className, weight, variant });
  return createElement(as, { className: style, ...rest }, children);
};
Text.displayName = "Text";
export {
  Text
};
